import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeComponent = _resolveComponent("HomeComponent")!
  const _component_TestimonialsComponent = _resolveComponent("TestimonialsComponent")!
  const _component_ProjectsComponent = _resolveComponent("ProjectsComponent")!
  const _component_AboutMeComponent = _resolveComponent("AboutMeComponent")!
  const _component_AqComponent = _resolveComponent("AqComponent")!
  const _component_MethodologyComponent = _resolveComponent("MethodologyComponent")!
  const _component_ContactComponent = _resolveComponent("ContactComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_HomeComponent, { id: "HOME" }),
    _createVNode(_component_TestimonialsComponent, { id: "TESTIMONIALS" }),
    _createVNode(_component_ProjectsComponent, { id: "PROJECTS" }),
    _createVNode(_component_AboutMeComponent, { id: "ABOUT_ME" }),
    _createVNode(_component_AqComponent, { id: "AQ" }),
    _createVNode(_component_MethodologyComponent, { id: "METHODOLOGY" }),
    _createVNode(_component_ContactComponent, { id: "CONTACT" }),
    _createVNode(_component_FooterComponent, { id: "FOOTER" }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
      "max-width": "900"
    }, {
      default: _withCtx(() => [
        (_ctx.selectedImage)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  src: _ctx.selectedImage.image,
                  height: "500"
                }, null, 8, ["src"]),
                _createVNode(_component_v_card_title, { class: "text-h5" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedImage.title), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_subtitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedImage.category), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedImage.description), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      text: "",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = false))
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode("Close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}